import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Will the order take longer/shorter?',
  text: {
    [OrderMethod.Pickup]:
      'The customer expects the order to be ready for pickup <strong>{{date}}</strong> at <strong>{{time}}</strong><br/> If necessary, you can change the time here.',
    [OrderMethod.OnSite]:
      'The customer expects the order at <strong>{{table}}</strong><br/><strong>{{date}}</strong> at <strong>{{time}}</strong><br/> If necessary, you can change the time here.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'The customer expects the order at their table <strong>{{date}}</strong> at <strong>{{time}}</strong><br/> If necessary, you can change the time here.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'The customer expects the order to be delivered <strong>{{date}}</strong> at <strong>{{time}}</strong><br/> If necessary, you can change the time here.',
      [DeliveryMode.External]: 'Driver will arrive to pick up order at <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Today',
  },
  confidence_labels: {
    estimated: ' (estimated!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Confirm new pickup time',
    confirm_on_site: 'Confirm new serve time',
    confirm_delivery: 'Confirm new delivery time',
  },
  confirmation_modal: {
    description: 'Are you sure you want to change the time from {{currentPickupTime}} to {{newPickupTime}}?',
    ok_button_text: 'Confirm new time',
    cancel_button_text: 'No, return original time',
  },
};
